import type { SearchResultItem } from "@core/features/support";
import { Type } from "@themes/pollinator/ui/Type";
import { Button } from "@themes/pollinator/ui/Button";

export type Props = {
  categoryName: string;
  items: SearchResultItem[];
  onItemClick: (item: SearchResultItem) => void;
};

export function SupportSearchFormResultItem({
  categoryName,
  items,
  onItemClick,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      <Type variant="h4" className="text-brand-700">
        {categoryName}
      </Type>
      <div>
        {items.map((item) => (
          <Button
            variant="ghost"
            onClick={() => onItemClick(item)}
            key={item.id}
            data-testid={`search-result-${item.id}`}
          >
            {item.title}
          </Button>
        ))}
      </div>
    </div>
  );
}

export default SupportSearchFormResultItem;

